import { fetch } from '../utils/fetch'
import { ENDPOINT_CONFIG } from '../constants'

const LOAD_CONFIG_REQUEST = 'blayzr/config/LOAD_REQUEST'
const LOAD_CONFIG_SUCCESS = 'blayzr/config/LOAD_SUCCESS'
const LOAD_CONFIG_ERROR = 'blayzr/config/LOAD_ERROR'

const SAVE_CONFIG_REQUEST = 'blayzr/config/SAVE_REQUEST'
const SAVE_CONFIG_SUCCESS = 'blayzr/config/SAVE_SUCCESS'
const SAVE_CONFIG_ERROR = 'blayzr/config/SAVE_ERROR'

const initialConfigState = {
  data: null,
  fetching: false,
  error: null,
  saving: false,
  saveError: null
}

export default function reducer (state = {}, action = {}) {
  const { type, meta } = action
  switch (type) {
    case LOAD_CONFIG_REQUEST:
    case LOAD_CONFIG_SUCCESS:
    case LOAD_CONFIG_ERROR:
    case SAVE_CONFIG_REQUEST:
    case SAVE_CONFIG_SUCCESS:
    case SAVE_CONFIG_ERROR:
      return {
        ...state,
        [meta.id]: configReducer(state[meta.id], action)
      }
    default:
      return state
  }
}

function configReducer (state = initialConfigState, action) {
  const { type, payload } = action
  switch (type) {
    case LOAD_CONFIG_REQUEST:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case LOAD_CONFIG_SUCCESS:
      return {
        ...state,
        fetching: false,
        data: payload
      }
    case LOAD_CONFIG_ERROR:
      return {
        ...state,
        fetching: false,
        error: payload
      }
    case SAVE_CONFIG_REQUEST:
      return {
        ...state,
        data: payload,
        saving: true,
        saveError: null
      }
    case SAVE_CONFIG_SUCCESS:
      return {
        ...state,
        saving: false
      }
    case SAVE_CONFIG_ERROR:
      return {
        ...state,
        saving: false,
        saveError: payload
      }
    default:
      return state
  }
}

export function loadConfigRequest (id) {
  return {
    type: LOAD_CONFIG_REQUEST,
    meta: { id }
  }
}

export function loadConfigSuccess (id, data) {
  return {
    type: LOAD_CONFIG_SUCCESS,
    payload: data,
    meta: { id }
  }
}

export function loadConfigError (id, error) {
  return {
    type: LOAD_CONFIG_ERROR,
    payload: error,
    meta: { id }
  }
}

export function saveConfigRequest (id, data) {
  return {
    type: SAVE_CONFIG_REQUEST,
    payload: data,
    meta: { id }
  }
}

export function saveConfigSuccess (id) {
  return {
    type: SAVE_CONFIG_SUCCESS,
    meta: { id }
  }
}

export function saveConfigError (id, error) {
  return {
    type: SAVE_CONFIG_ERROR,
    payload: error,
    meta: { id }
  }
}

export function loadConfig (id, defaultValue) {
  return (dispatch, getState) => {
    const { auth } = getState()
    const options = {
      token: auth.token,
      query: { id }
    }
    dispatch(loadConfigRequest(id))
    return fetch(ENDPOINT_CONFIG, options, dispatch).then(data => {
      const value = data.records ? JSON.parse(data.records.value) : defaultValue
      dispatch(loadConfigSuccess(id, value))
      return value
    }, e => {
      dispatch(loadConfigError(id, e))
    })
  }
}

export function saveConfig (id, data) {
  console.log(id, data)
  return (dispatch, getState) => {
    const { auth } = getState()
    const options = {
      method: 'post',
      token: auth.token,
      body: {
        id,
        value: JSON.stringify(data)
      }
    }
    dispatch(saveConfigRequest(id, data))
    return fetch(ENDPOINT_CONFIG, options, dispatch).then(data => {
      dispatch(saveConfigSuccess(id))
    }, e => {
      dispatch(saveConfigError(id, e))
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/config.js